import { apiFetch } from "./client.ts";

export interface TwilioCredsStatus {
  configured: boolean;
  enabled: boolean;
  has_messaging_service: boolean;
}

export interface SiteTwilioConfig {
  twilio_number_e164: string | null;
  dispatcher_numbers: string[];
  business_hours: Record<string, [string, string][]> | null;
  recording_enabled: boolean | null;
  recording_notice: string | null;
  after_hours_message: string | null;
  ivr_enabled: boolean | null;
  ivr_welcome_message: string | null;
  ivr_menu_message: string | null;
  ivr_voicemail_prompt: string | null;
}

export const getTwilioStatus = () => apiFetch<TwilioCredsStatus>("/integrations/twilio/status");
export const upsertTwilioCredentials = (payload: {
  account_sid: string;
  auth_token: string;
  messaging_service_sid?: string;
  enabled?: boolean;
}) =>
  apiFetch<{ status: string }>("/integrations/twilio/credentials", {
    method: "PUT",
    body: JSON.stringify({ ...payload, enabled: payload.enabled ?? true }),
  });
export const deleteTwilioCredentials = () =>
  apiFetch<void>("/integrations/twilio/credentials", { method: "DELETE" });

export const getSiteTwilioConfig = (siteId: string) =>
  apiFetch<SiteTwilioConfig>(`/integrations/twilio/sites/${siteId}`);
export const upsertSiteTwilioConfig = (siteId: string, payload: Partial<SiteTwilioConfig>) =>
  apiFetch<SiteTwilioConfig>(`/integrations/twilio/sites/${siteId}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });
